import Record from '../Record'

export default class InvoiceForm extends Record {

    constructor (data) {
        super(data)
		return this._proxy
	}

	static async fetch (id = null) {
		if (id == null) {

			const size = 'A4'

			// Create record
			return new InvoiceForm({

                // Műveleti utasítás a felhőnek
                action: 'preview',      				// 'preview' - előnézet | 'issue' - kiállítás
                format: size,           				// 'A4' | '80'
				mode: 'pdf',							// 'pdf' | 'html'
                send_email: false,      				// true, ha el is kell küldeni emailben (csak kiállítás esetén értelmezett)

                // Vevő
                customer_uuid: '',
                customer_name: '',
                customer_email: '',
                customer_country: 'HU',
                customer_area_code: '',
                customer_city: '',
                customer_address: '',
                customer_tax_type: null,
                customer_tax_number: '',
                customer_group_tax_number: '',
                customer_eu_tax_number: '',

                // Számla fej
                invoice_currency: 'HUF',
                invoice_d: Anvil.moment().format('YYYY-MM-DD'),
                invoice_complete_d: Anvil.moment().format('YYYY-MM-DD'),
                invoice_payment_method: 2,
                invoice_payment_d: Anvil.moment().format('YYYY-MM-DD'),

				invoice_group: 18,
				invoice_comment: '',

                items: []
			})
		} else {
            throw new Error('Not implemented')
		}
	}

	async commit () {

        // Validate
        if (!this.validate())
            throw new Error('Kérjük ellenőrizze a megadott adatokat.')

        // Lezárás esetén mentsük a vevőt
		/*
		if (this._data.action == 'issue') {
			await Anvil.models.c_order.Customer.saveInvoiceCustomer(this._proxy)
		}
		*/

		// Clone data
		const data = { ...this._proxy }
		data.items = data.items.filter(item => item.include)

		const res = await Anvil.REST.post(`/cstore_api/v5/c-order/push_invoice`, data)
		if (!res.success) {
			throw new Error(res.error)
		}

        // Handle response elsewhere
        return res
	}

	validation_schema = {
        customer_name: [ 'required' ],
        customer_area_code: [ 'required' ],
        customer_city: [ 'required' ],
        customer_address: [ 'required' ],
        customer_tax_type: [ 'required' ],
        invoice_currency: [ 'required' ],
        invoice_d: [ 'required' ],
        invoice_complete_d: [ 'required' ],
        invoice_payment_method: [ 'required' ],
        invoice_payment_d: [ 'required' ]
	}
}
